import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import styles from "./styles.module.scss";
import { QuoteIcon } from "../Icons";

type Depoimento = {
  texto: string;
  nome: string;
  handle: string;
  avatar: string;
};

const DEPOIMENTOS: Depoimento[] = [
  {
    texto:
      "“Trabalhar com o Parceiros Promo tem sido muito gratificante! Além de ter produtos diversificados, os ganhos são muito positivos, a plataforma é amigável e me sinto sempre amparada pelo suporte da marca. É algo que confio e indico justamente por sentir que sempre tem gente disposta a me auxiliar no que eu preciso. E é um serviço necessário que nunca vi outra marca no mercado oferecendo de forma tão completa. Pretendo continuar com essa parceria por mais longos anos! ❤️”",
    nome: "Fernanda Firmato",
    handle: "Libretd",
    avatar: "/images-capa2/depoimentos/fernanda.png",
  },
  {
    texto:
      "“O contato direto com o time e a ferramenta incrível para gestão dos resultados, com certeza são grandes diferenciais do Parceiros Promo. Parceiros desde o início do projeto e que agregam muito pela troca de conhecimentos. Uma verdadeira parceria!”",
    nome: "Matheus Petruceli",
    handle: "Petruceli",
    avatar: "/images-capa2/depoimentos/matheus.png",
  },
  {
    texto:
      "“O Dicas Nova York está junto com o Parceiros Promo desde 2017. De lá para cá, essa troca nos trouxe muito aprendizado e resultado em vendas. Trabalhar com o Parceiros Promo é ter tranquilidade para ajudar os leitores com produtos de viagem e ter uma parceria para todas as horas. Construímos uma amizade ao longo dos anos e somos muito felizes em trabalhar e indicar o Parceiros Promo para todos os produtores de conteúdo! Esperamos que nossa união continue por muito mais tempo.”",
    nome: "Fabinho",
    handle: "Dicas Nova York",
    avatar: "/images-capa2/depoimentos/fabinho.png",
  },
];

const DepoimentosV2: React.FC = () => {
  return (
    <section className={styles.depoimentos}>
      <h2>O que falam do Parceiros Promo?</h2>

      <div className={styles.carousel}>
        <Swiper
          modules={[Pagination, Navigation, Autoplay]}
          pagination={{ clickable: true }}
          navigation
          autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
          spaceBetween={16}
          slidesPerView={1}
          breakpoints={{
            1024: { slidesPerView: 3 },
            700: { slidesPerView: 2 },
          }}
        >
          {DEPOIMENTOS.map((d) => (
            <SwiperSlide key={d.nome}>
              <article className={styles.card}>
                <div
                  className={styles.avatar}
                  style={{ backgroundImage: `url(${d.avatar})` }}
                />
                <p className={styles.texto}>{d.texto}</p>
                <div className={styles.author}>
                  <span className={styles.nome}>{d.nome}</span>
                  <span className={styles.handle}>{d.handle}</span>
                </div>
                <span className={styles.quote}>
                  <QuoteIcon size={40} />
                </span>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default DepoimentosV2;
